import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  giorni: [
    {
      weekDay: 1,
      giorno: 'LUN',
      isClosed: true,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 2,
      giorno: 'MAR',
      isClosed: false,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 3,
      giorno: 'MER',
      isClosed: false,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 4,
      giorno: 'GIO',
      isClosed: false,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 5,
      giorno: 'VEN',
      isClosed: false,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 6,
      giorno: 'SAB',
      isClosed: false,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
    {
      weekDay: 7,
      giorno: 'DOM',
      isClosed: true,
      orari: [{
        dal: '08:00', all: '12:00', dal2: '13:00', all2: '20:00',
      }],
    },
  ],
};

export const orariSlice = createSlice({
  name: 'orari',
  initialState,
  reducers: {
    setOrariData: (state, action) => ({
      ...state,
      giorni: action.payload.giorni,
    }),

  },
});

// Action creators are generated for each case reducer function
export const { setOrariData } = orariSlice.actions;
export const orariSelector = (state) => state.orari.orari;
export default orariSlice.reducer;
